/** @format */

import { Component, Input, OnInit } from '@angular/core';

import { CommonModule } from '@angular/common';

@Component({
	selector: 'common-progress-spinner',
	templateUrl: './progress-spinner.component.html',
	styleUrl: './progress-spinner.component.scss',
	imports: [CommonModule]
})
export class ProgressSpinnerComponent implements OnInit {
	@Input() diameter: string;
	@Input() strokeColor: string;
	@Input() strokeWidth: string;

	ngOnInit() {
		this.diameter = `${parseFloat(this.diameter) / 10}rem`;
		this.strokeWidth = `${parseFloat(this.strokeWidth) / 10}rem`;
	}
}
